import React, { ReactElement, CSSProperties } from "react";
import styles from "./Button.module.css";

interface ButtonProps {
  /**
   * disable the button
   */
  disabled?: boolean;
  /**
   * Color of the button
   */
  color?: "red" | "blue" | "green" | "grey" | "white" | "default";
  /**
   *  Size of the button
   */
  size?: "lg" | "sm" | "md";
  /**
   * Custom class name to be added to the button
   */
  className?: string;
  /**
   * Text to display inside the button
   */
  text: string;
  /**
   * A11y name to apply to the button
   */
  name: string;
  /**
   *  Function to call on click
   */
  onClick?: (ev: React.MouseEvent<HTMLButtonElement>) => void;
  /**
   * Add additional styles
   */
  style?: CSSProperties;
  /**
   * Type of the buttob
   */
  type?: "submit" | "reset" | "button"
}

const Button: React.FC<ButtonProps> = ({
  disabled = false,
  color = "grey",
  size,
  className = "df-btn",
  text,
  name,
  onClick,
  style,
  ...props
}): ReactElement => {
  const getColor = (color: string | undefined) => {
    switch (color) {
      case "red":
        return `${styles.red}`;
      case "blue":
        return `${styles.blue}`;
      case "green":
        return `${styles.green}`;
      case "grey":
        return `${styles.grey}`;
      case "white":
        return `${styles.white}`;
      default:
        return `${styles.grey}`;
    }
  };

  const getSize = (size: string | undefined) => {
    switch (size) {
      case "lg":
        return styles["btn-lg"];
      case "md":
        return styles["btn-md"];
      case "sm":
        return styles["btn-sm"];
      default:
        return "";
    }
  };

  return (
    <button
      {...props}
      disabled={disabled}
      className={`${styles.button}  ${className} ${getColor(color)} ${getSize(size)}`}
      onClick={onClick}
      name={name}
      style={{ ...style }}
    >
      {text}
    </button>
  );
};

export default Button;
